
export enum VideoType {
  Vehicle = 'Vehicle-Focused',
  Trending = 'Trending / Viral Style',
}

export enum VideoStyle {
  Funny = 'Funny & Relatable',
  Informative = 'Informative Tech Deep-Dive',
  Luxury = 'Luxury Showcase',
  Action = 'Action-Packed Test Drive',
  Storytelling = 'Customer Storytelling',
  QuickTip = 'Quick Tip / Hack',
  BehindTheScenes = 'Behind-the-Scenes',
  DayInTheLife = 'Day in the Life',
  Comparison = 'This vs That Comparison',
}

export enum CtaOption {
  Comment = 'Ask for comments/engagement',
  TestDrive = 'Book a test drive',
  VisitWebsite = 'Visit the website/link in bio',
  Follow = 'Follow for more content',
  Share = 'Share with a friend',
  ContactUs = 'Contact us for details',
}

export interface ScriptFormData {
  videoType: VideoType;
  make: string;
  model: string;
  year: string;
  keyFeatures: string;
  targetAudience: string;
  videoStyle: VideoStyle;
  cta: CtaOption;
}

export interface SavedTemplate {
  id: string;
  userId: string;
  timestamp: number;
  formData: ScriptFormData;
  script: string;
}

export interface User {
  id: string;
  username: string;
  isLoggedIn: boolean;
}
